import tw, { styled, css } from "twin.macro"

export const CalloutCard = styled.div`
  ${tw`relative block`}
  ${({ cols, rows, gridView, colsNumber }) =>
    css`
      grid-column: auto / span 1;
      grid-row: auto / span 1;
      @media (min-width: 1024px) {
        grid-column: auto / span ${cols};
        grid-row: auto / span ${rows};
        ${!gridView && colsNumber >= 4 && `grid-column: auto / span 2`}
    `}
  ${({ backgroundColor }) =>
    css`
      background-color: ${backgroundColor};
    `}
  ${({ textColor }) =>
    css`
      color: ${textColor};
    `}
  ${css`
    height: 100%;
  `}
  
  ${({ colsNumber }) => colsNumber >= 4 && `
    .media-element {
      position: relative;

      img {
        position: relative !important;
      }
    }
  `}
`

export const Media = styled.div`
  ${tw`h-full w-full absolute top-0 left-0`}
  ${({ layout }) => (layout == "mobile" ? tw`lg:hidden` : tw`hidden lg:block`)}
`

export const Content = tw.div`
  relative z-10 p-4
`
